export function transformExcelToLeaveDetails(
  excelData,
  employeeLeaveOptions,
  userName
) {
  const leaveYear = new Date().getFullYear();

  return excelData.flatMap((row) => {
    const employeeCode = row["Unique Id"];

    return Object.keys(row)
      .filter((key) => key !== "Unique Id")
      .map((leaveLabel) => {
        const leaveOption = employeeLeaveOptions.find(
          (opt) => opt.label === leaveLabel
        );

        const days = Number(row[leaveLabel]) || 0;

        return {
          slNo: 0,
          companyCode: 0,
          employeeCode: employeeCode,
          leaveCode: leaveOption?.value || 0,
          leaveYear,
          noOfAllotedDays: days,
          uniqueId: employeeCode,
          noOfLeaveCarryForwardFromLastYear: 0,
          leaveTaken: 0,
          leaveCarryForwardtoNextYear: 0,
          amountPaidForLeaveDays: 0,
          balanceLeaveDays: 0,
          totalLeaveDays: days,

          createDate: new Date().toISOString(),
          modifyDate: new Date().toISOString(),
          user: userName,
        };
      });
  });
}
